import { PhoneHangupIcon } from './PhoneHangupIcon';

/**
 * author: Google
 * id 2018B4C8-A296-4D62-A30A-85F988B206EA
 * name phone-hangup
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-hangup.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneHangupIcon = PhoneHangupIcon;
export default TelephoneHangupIcon